import { Button } from "@svea/design-system-components-react";
import {
	ButtonGroup,
	Dialog,
	getHasSelectedConsent,
	getTrackingFns,
	Markdown,
	setLocalTrackingConsent,
	useBasePath,
	useText,
} from "@sveabank/cc-common";
import { useState } from "react";

const ConsentModal = () => {
	const pathName = useBasePath();

	const hasSelectedConsent = getHasSelectedConsent();

	const [t, texts] = useText();

	const [isOpen, setIsOpen] = useState(!hasSelectedConsent);

	const { trackPageView } = getTrackingFns(window.Matomo);

	const declineTracking = () => {
		setLocalTrackingConsent(false);
		setIsOpen(false);
	};
	const acceptTracking = () => {
		setLocalTrackingConsent(true);
		trackPageView(pathName);
		setIsOpen(false);
	};

	if (hasSelectedConsent) return null;

	return (
		<Dialog
			isDismissable={false}
			size="small"
			center
			isOpen={isOpen}
			heading={t(texts.loginPage.consentModal.heading)}
		>
			<Dialog.Content>
				<Markdown allowParagraphs>{t(texts.loginPage.consentModal.body)}</Markdown>
			</Dialog.Content>
			<ButtonGroup>
				<Button onPress={acceptTracking}>{t(texts.loginPage.consentModal.accept)}</Button>
				<Button onPress={declineTracking} variant="secondary">
					{t(texts.loginPage.consentModal.decline)}
				</Button>
			</ButtonGroup>
		</Dialog>
	);
};

export default ConsentModal;
